// REMOVE when flow component is finished

// Params
//   - label: string       --> label of the node
//   - children: array     --> array of children nodes
//   - type: string        --> type of the node (split, ???)
//   - condition: string   --> condition of the node (Condition to print on node header)
//   - context: string     --> context of the node (message or something to render inside node)
//   - dropAbove: boolean  --> can drop above this node
//   - dropBelow: boolean  --> can drop below this node
//   - noDelete: boolean   --> can delete this node
//   - noMove: boolean     --> can move this node

const treeForm = {
  label: '1',
  noDelete: true,
  dropAbove: false,
  noMove: true,
  children: [
    {
      label: '2',
      dropBelow: true,
      children: [
        {
          label: 'split',
          type: 'split',
          children: [
            {
              label: 'Novi član',
              dropAbove: false,
              type: 'split-condition',
              children: [
                {
                  condition: 'If',
                  label: 'Poruka',
                  context: 'asdfg',
                  children: [
                    {
                      type: 'split',
                      label: 'Split Neki jako nerealno dugačak condition za test koji mora biti odrezan na kraju sa tri točkice',
                      children: [
                        {
                          dropAbove: false,
                          type: 'split-condition',
                          condition: 'Test condition',
                          label: 'aaa Opcija 1 Neki jako nerealno dugačak condition za test koji mora biti odrezan na kraju sa tri točkice',
                          children: [
                            {
                              label: 'Opcija 2',
                              children: [
                                {
                                  label: 'Opcija 3',
                                  context: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Nisl rhoncus mattis rhoncus urna neque viverra. Viverra maecenas accumsan lacus vel facilisis. Porta lorem mollis aliquam ut porttitor leo a diam. Ridiculus mus mauris vitae ultricies leo integer. Semper feugiat nibh sed pulvinar proin gravida. Eget dolor morbi non arcu risus. Euismod in pellentesque massa placerat. Sodales ut etiam sit amet. Arcu felis bibendum ut tristique et egestas quis ipsum suspendisse. Sollicitudin tempor id eu nisl nunc mi ipsum faucibus vitae. Malesuada nunc vel risus commodo viverra maecenas accumsan. Mauris pharetra et ultrices neque euismod. Tempus imperdiet nulla malesuada pellentesque. Diam volutpat commodo sed egestas egestas. \n\nDonec ac odio tempor orci dapibus ultrices in iaculis. Sed viverra tellus in hac habitasse platea dictumst vestibulum. Suspendisse potenti nullam ac tortor vitae purus faucibus. Risus feugiat in ante metus dictum at tempor commodo. Faucibus et molestie ac feugiat sed lectus vestibulum. Aenean euismod elementum nisi quis eleifend. Aliquam ultrices sagittis orci a scelerisque purus semper eget duis. Ornare aenean euismod elementum nisi quis eleifend quam adipiscing. Imperdiet sed euismod nisi porta lorem mollis aliquam ut. Urna duis convallis convallis tellus id interdum. Feugiat in fermentum posuere urna nec tincidunt praesent semper feugiat.',
                                  children: [
                                    {
                                      label: 'Opcija 4',
                                      children: [
                                        {
                                          label: 'Opcija 5',
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                        {
                          label: 'Opcija 2',
                          type: 'split',
                          children: [
                            {
                              condition: 'Neki jako nerealno dugačak condition za test koji mora biti odrezan na kraju sa tri točkice',
                              label: 'Neka jako dugačka radnja koja mora biti odrezana na kraju sa tri točkice',
                              type: 'split-condition',
                              dropAbove: false,
                              children: [
                                { label: 'Test' },
                              ],
                            },
                            { label: 'Nazovi', type: 'split-condition', dropAbove: false },
                            { label: 'Treći za brisanje', type: 'split-condition', dropAbove: false },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              type: 'split',
              label: '3',
              children: [
                { label: '4', type: 'split-condition', dropAbove: false },
                {
                  type: 'split',
                  label: '5',
                  children: [
                    { label: '6', type: 'split-condition', dropAbove: false },
                    { label: '7', type: 'split-condition', dropAbove: false },
                  ],
                },
                { label: 'Treća opcija', type: 'split-condition', dropAbove: false },
              ],
            },
          ],
        },
      ],
    },
  ],
};

const flatForm = [];

export {
  treeForm,
  flatForm,
};
